import * as React from 'react';
import { BodyText } from '@sheinc/shelikes-design-system';
import { UserTutorialCompletionKey } from '../../../types/userTutorialCompletions';
import ImageStartCourse from './images/start_course.png';

export function userTutorialDetailTexts(key: UserTutorialCompletionKey) {
  switch (key) {
    case UserTutorialCompletionKey.KEY_COMPLETE_TUTORIAL_COURSE:
      return {
        title: 'SHElikesの使い方コースを受講しよう',
        description: (
          <>
            <BodyText>
              「SHElikesの使い方」コースを受講しましょう！SHElikesで提供しているサービスを活用いただくために必要な情報がまとまっています。
            </BodyText>
            <BodyText>
              ※レッスン視聴のページで、動画視聴後、「次へ進む」または「レッスンを完了して次へ進む」ボタンを押すとレッスンが受講完了されたこととなります。
            </BodyText>
            <BodyText>
              ※本コース内の全てのレッスンで受講を完了されると、「SHElikesの使い方コースを受講しよう」のステップが完了となります。
            </BodyText>
          </>
        ),
        comment: 'STEP1でご案内した「SHElikesスタートダッシュ講座」にも併せて参加するのがおすすめです！',
      };
    case UserTutorialCompletionKey.KEY_JOIN_SLACK:
      return {
        title: 'SHEstationに登録しよう',
        description: (
          <>
            <BodyText>SHEstationとは、SHEで利用しているSHElikesコミュニティサイトです。</BodyText>
            <BodyText>
              SHEではSHEstationでのコミュニケーションを通して、シーメイトさん同士で交流をしたり、シーメイトさんたちの企画するイベント情報を受け取ったりすることができます。
            </BodyText>
            <BodyText>
              もくもく会の参加、制作物のフィードバックやご質問等、講師との連絡もSHEstationを利用して行いますので、必ずご登録をお願いいたします。
            </BodyText>
            <BodyText>
              SHEstationの登録方法・使い方は
              <a
                href="https://docs.google.com/presentation/d/1d4nJyhf3krifOa1FJ8WIgUw1wxsNmAnBf6wTSImjLho/edit"
                target="_blank"
              >
                こちら
              </a>
            </BodyText>
            <BodyText>
              （上記スライドは、SHEstationにご参加いただいた後、「はじめての方へ」ボックス内の「基本的な使い方」カテゴリでもご確認いただけます。）
            </BodyText>
          </>
        ),
        comment: 'SHEstationに登録できたら「はじめての方へ」ボックスを見てみよう♪',
      };
    case UserTutorialCompletionKey.KEY_START_COURSE:
      return {
        title: '気になるコースを1つ選んで受講してみよう！',
        description: (
          <>
            <BodyText>
              コース一覧ページから、気になるコースを選んで受講してみましょう！コースは、PC・スマートフォン・タブレットで視聴ができます。
            </BodyText>
            <BodyText>
              コース一覧ページは、<a href="/courses">こちら</a>から！
            </BodyText>
            <img src={ImageStartCourse} styleName="" />
            <BodyText>
              コース選びに悩んだときは、マイページの「コース一覧」ページに記載のおすすめセットもぜひ参考にしてみてください！
            </BodyText>
            <BodyText>
              また、SHEsharesの記事を読んで、理想に近い変化を遂げている先輩の受講コースを参考にしたり、Welcomeワークショップで描いたご自身の理想を叶えるために近いコースを当てはめたりしてみてくださいね！
            </BodyText>
            <BodyText>
              Welcomeワークショップは、STEP3でご案内しています。 SHEsharesは、
              <a href="https://shelikes.jp/shares/">こちら</a>からチェック！
            </BodyText>
          </>
        ),
        comment:
          'どのコースや職種が向いているかは百人百色！もし「違うかも？」と思ったら、違うコースを受講してみてください。あなたの好きや得意が見つかりますように！',
      };
    case UserTutorialCompletionKey.KEY_ATTEND_START_DASH:
      return {
        title: 'スタートダッシュ講座に参加しよう！',
        description: (
          <>
            <BodyText>専用ページから「スタートダッシュ講座」を予約してみよう！</BodyText>
            <BodyText>入会後、受講中に悩みやすいポイントを解消するヒントが先回りして学べるイベントです！</BodyText>
            <BodyText>
              今後スムーズにSHElikesの受講を始めていただくために、入会したばかりのタイミングで皆さまにご参加いただきたいイベントです。
              入会後2ヶ月までを目安にご予定を調整の上、ぜひご参加ください。
            </BodyText>
          </>
        ),
        comment: (
          <>
            カメラ/マイクOFFでお気軽にご参加いただけます。
            イベント参加までに時間がある方は、事前に「SHElikesの使い方コース」を見ておいてくださいね!
          </>
        ),
      };
    case UserTutorialCompletionKey.KEY_ATTEND_WELCOME_WORKSHOP:
      return {
        title: 'Welcomeワークショップに参加しよう！',
        description: (
          <>
            <BodyText>
              Welcomeワークショップでは、ご自身の価値観の言語化や理想の未来を描き、これから始まるSHEライフがより充実するような土台作りを行います。
            </BodyText>
            <BodyText>
              また、同時期にSHEをスタートした方々との交流もあり、仲間づくりの場としても最適です。できるだけ受講開始から間を空けずに参加いただくことをお勧めします。
            </BodyText>
            <BodyText>※Welcomeワークショップ参加前でもコースは受講いただけます。</BodyText>
          </>
        ),
        comment: (
          <>
            Welcomeワークショップでどんなことをするのか、『コーチングとは』の動画を見てみましょう♪
            SHEライフコーチングについては、『コーチングガイド』を見てみてくださいね！参加までの事前準備や、ライフコーチ総勢約60名のプロフィールを掲載しています♪
          </>
        ),
      };
    default:
      return {
        title: '',
        description: '',
        comment: '',
      };
  }
}
